/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Outline_Opacity_LabelInputs */

const en_video_export_outline_opacity_label = /** @type {(inputs: Video_Export_Outline_Opacity_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outline Opacity`)
};

const fr_video_export_outline_opacity_label = /** @type {(inputs: Video_Export_Outline_Opacity_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opacite du contour`)
};

const de_video_export_outline_opacity_label = /** @type {(inputs: Video_Export_Outline_Opacity_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konturdeckkraft`)
};

const it_video_export_outline_opacity_label = /** @type {(inputs: Video_Export_Outline_Opacity_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opacità del contorno`)
};

const ru_video_export_outline_opacity_label = /** @type {(inputs: Video_Export_Outline_Opacity_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прозрачность контура`)
};

const es_video_export_outline_opacity_label = /** @type {(inputs: Video_Export_Outline_Opacity_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opacidad del contorno`)
};

const zh_cn2_video_export_outline_opacity_label = /** @type {(inputs: Video_Export_Outline_Opacity_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`轮廓不透明度`)
};

const ja_video_export_outline_opacity_label = /** @type {(inputs: Video_Export_Outline_Opacity_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アウトラインの不透明度`)
};

const hi_video_export_outline_opacity_label = /** @type {(inputs: Video_Export_Outline_Opacity_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रूपरेखा अपारदर्शिता`)
};

const pt_pt2_video_export_outline_opacity_label = /** @type {(inputs: Video_Export_Outline_Opacity_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opacidade do contorno`)
};

/**
* | output |
* | --- |
* | "Outline Opacity" |
*
* @param {Video_Export_Outline_Opacity_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_outline_opacity_label = /** @type {((inputs?: Video_Export_Outline_Opacity_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Outline_Opacity_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_outline_opacity_label(inputs)
	if (locale === "de") return de_video_export_outline_opacity_label(inputs)
	if (locale === "it") return it_video_export_outline_opacity_label(inputs)
	if (locale === "ru") return ru_video_export_outline_opacity_label(inputs)
	if (locale === "es") return es_video_export_outline_opacity_label(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_outline_opacity_label(inputs)
	if (locale === "ja") return ja_video_export_outline_opacity_label(inputs)
	if (locale === "hi") return hi_video_export_outline_opacity_label(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_outline_opacity_label(inputs)
	return en_video_export_outline_opacity_label(inputs)
});